import { v4 as uuidV4 } from 'uuid';

export const TOAST_LIST_RESET = 'TOAST_LIST_RESET';
export const TOAST_ADD = 'TOAST_ADD';
export const TOAST_REMOVE = 'TOAST_REMOVE';
export const TOAST_DURATION_MS = 5000;
export const TOAST_TRANSITION_DURATION_MS = 300;

export function reset() {
  return {
    type: TOAST_LIST_RESET,
  };
}

export const remove = uuid => ({
  type: TOAST_REMOVE,
  payload: uuid,
});

export function add({
  type,
  message,
  id = uuidV4(),
  duration = TOAST_DURATION_MS,
}) {
  return dispatch => {
    const toast = {
      uuid: id,
      type,
      message,
      duration,
    };
    // schedule removal of this toast
    const removeAction = remove(id);
    const dispatchRemoveFunction = dispatch.bind(this, removeAction);

    if (duration > 0 && type !== 'error')
      setTimeout(dispatchRemoveFunction, duration);

    // show toasts now that we've added one to the list
    return dispatch({
      type: TOAST_ADD,
      payload: toast,
    });
  };
}
